// FILE: src/services/accessLinks.js
// Reviewer access links (plan WP-2b). Admin calls go through fetchWithAuth;
// the public steps through apiFetch (no session yet). Failures reject with
// the server body so pages can use errorMessage() and attemptsRemaining.
import { apiFetch } from "./api";
import fetchWithAuth from "../utils/fetchWithAuth";

async function publicCall(path, body) {
  const res = await apiFetch(path, body === undefined ? {} : {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body)
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw Object.assign(new Error(data.code || "NETWORK"), { code: data.code || "NETWORK", body: data, status: res.status });
  return data;
}

const enc = encodeURIComponent;

export const listAccessLinks = () => fetchWithAuth("/api/admin/access-links");
export const createAccessLink = (kind, label) =>
  fetchWithAuth("/api/admin/access-links", { method: "POST", body: JSON.stringify({ kind, label }) });
export const revokeAccessLink = (id) => fetchWithAuth(`/api/admin/access-links/${enc(id)}/revoke`, { method: "POST", body: "{}" });

export const openAccessLink = (token) => publicCall(`/api/public/access-links/${enc(token)}`);
export const startAccessLink = (token, email) => publicCall(`/api/public/access-links/${enc(token)}/start`, { email });
export const claimAccessLink = (token, body) => publicCall(`/api/public/access-links/${enc(token)}/claim`, body);

export const KIND_OPTIONS = [
  {
    value: "STUDENT_TIMED",
    label: "Student – timed LMS",
    hint: "A student account with every course rule on: the 5-hour daily limit, breaks and page timers."
  },
  {
    value: "STUDENT_UNTIMED",
    label: "Student – untimed LMS",
    hint: "A student account without the time rules, to look through the whole course quickly. Only where untimed accounts are allowed."
  },
  { value: "ADMIN", label: "Administrative access", hint: "An administrator account: students, records, support and reports." }
];

/** Ready-to-paste email for one or more links (for the MTO reviewers). */
export function reviewerEmailText(links) {
  const lines = [
    "Hello,",
    "",
    links.length > 1
      ? "Here are your private links to review the Zun Drivers Beginner Driver Education course."
      : "Here is your private link to review the Zun Drivers Beginner Driver Education course.",
    "Each link works once. Open it, enter your own email address, type the code we email you, and choose a password and five security questions. From then on you sign in at the course website with your email, password and an emailed code.",
    ""
  ];
  for (const l of links) {
    lines.push(`${l.kindLabel || l.label}:`, l.url, "");
  }
  lines.push("Please don't forward these links: anyone who opens one first gets that account.", "", "Thank you,", "Zun Drivers");
  return lines.join("\n");
}
